import * as React from 'react';
const SvgLinkedIn = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>
        <path
            fill='currentColor'
            d='M13.495 7.554q.162.007.316.025c1.745.19 2.735 1.336 2.735 3.283v5.69H13.81v-5.085c0-.127-.032-1.493-1.544-1.493-.51 0-.965.227-1.217.68-.296.542-.252 1.172-.252 1.764v4.097H8.063V7.793h2.616v1.166s.037-.064.119-.17a3.19 3.19 0 0 1 2.697-1.235m-7.083 8.935H3.677V7.768h2.735zM5.045 3.464a1.588 1.588 0 1 1 0 3.176 1.588 1.588 0 0 1 0-3.176'
        />
    </svg>
);
export default SvgLinkedIn;
